const News = {
  btnLoadMore: null,

  init: () => {
    // check if page is news archive...
    const isNewsArchive = document.querySelector("body.post-type-archive-news");
    if (!isNewsArchive) return;

    // find load more button for news archive
    News.btnLoadMore = document.getElementById("news-load-more");

    if (News.btnLoadMore) {
      // news load more button: activate!!!
      News.btnLoadMore.addEventListener("click", function () {
        News.btnLoadMore.classList.add("animate--pulsate");
        News.btnLoadMore.innerText = "Laddar...";
        News.handleSubmit();
      });
    }
  },

  handleSubmit: () => {
    // digi ajax url
    let url = digiteketData.ajaxUrl;

    // get next page
    digiteketData.currentPage++;

    // setup fetch data
    const data = {
      action: "digi_news_load_more",
      nonce: digiteketData.nonce,
      paged: digiteketData.currentPage,
    };

    // encode query data to be sent
    const query = News.encodeData(data);

    // append query data to ajax url
    if (query.length) {
      url += "?" + query;
    }

    // config fetch options
    const options = {
      method: "GET",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    };

    // load more news posts
    fetch(url, options)
      .then((res) => {
        // promise returned
        if (!res.ok) throw new Error(`HTTP error: ${res.status}`);
        return res.json();
      })
      .then((res) => {
        // success
        const data = res.data;

        // get pre-rendered post items
        const items = data.items;

        // get posts wrapper
        const resultsWrapper = document.getElementById("results");

        if (items && items.length != -1) {
          if (resultsWrapper) {
            items.forEach((item, index) => {
              // render each post item to the DOM
              resultsWrapper.insertAdjacentHTML("beforeend", item);

              if (index === 0) {
                // set focus to first new post item
                resultsWrapper.lastChild.focus();
              }
            });
          }
        }

        // update maxPage
        digiteketData.maxPage = data.maxNumPages;

        News.btnLoadMore.classList.remove("animate--pulsate");

        // update btn status
        if (digiteketData.currentPage == digiteketData.maxPage) {
          News.btnLoadMore.setAttribute("disabled", "");
          News.btnLoadMore.remove();
        } else {
          News.btnLoadMore.removeAttribute("disabled");
          News.btnLoadMore.innerText = "Ladda fler nyheter";
        }
      })
      .catch((err) => {
        // error
        console.log(err);

        // update btn status
        News.btnLoadMore.classList.remove("animate--pulsate");
        News.btnLoadMore.removeAttribute("disabled");
        News.btnLoadMore.innerText = "Ladda fler nyheter";
      });
  },

  encodeData: (data) => {
    const payload = [];

    for (const [key, value] of Object.entries(data)) {
      payload.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
    }

    return payload.join("&");
  },
};

export default News;
